import classNames from "classnames";

import { DComponent } from "../../../DComponent";
import { Auth } from "../../../../models/auth";

export default class OtherAuth extends DComponent {
  constructor({
    parent,
    id,
    provider,
    listAuth = [],
    onChangeAuth = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("OtherAuth", {

      }),
    });
    this.provider = provider;
    this.listAuth = listAuth;
    this.onChangeAuth = onChangeAuth;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "OtherAuth");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    let listData = Auth.LIST_AUTH;
    Array.isArray(this.listAuth) && this.listAuth.length &&
      listData.forEach(element => {
        if (this.listAuth.find(item => item.code === element.provider)) {
          element.hide = false;
        }
      });
    this.fillData(listData);
    this.addEvent();
  }

  fillData(listData = []) {
    $(".other-login", this.element).html("");
    $(".active-login", this.element).html("");
    let html = "", count = 0;
    listData.forEach(element => {
      if (!element.hide) count += 1;
      html = `
        <div type="${element.type || ""}" provider="${element.provider}" class="icon-login${element.hide ? " hide" : ""}">
          <img alt="icon" src="${element.icon}" />
          <span data-i18n="${element.label}"></span>
        </div>
      `
      $(".other-login", this.element).append(html);
      $(".active-login", this.element).append(html);
    });
    $(".or", this.element).toggleClass("hide", count < 2);
  }

  addEvent() {
    $(".icon-login", this.element).on("click", (e) => {
      let provider = $(e.currentTarget).attr("provider");
      if (!Object.values(Auth.TYPE).includes(provider)) return;
      this.onChange(provider);
    })
  }

  onChange(provider, isDefault = false) {
    $(".icon-login", this.element).removeClass("active");
    $(`.icon-login[provider='${provider}']`, this.element).addClass("active");

    if (!isDefault && (Auth.isSocialProvider(provider) || provider !== this.provider)) {
      typeof this.onChangeAuth === "function" && this.onChangeAuth(provider);
    }
    this.provider = provider;
  }

  setListProvider(list = []) {
    $(".icon-login", this.element).addClass("hide");
    list.forEach(element => {
      $(`.icon-login[provider='${element.code}']`, this.element).removeClass("hide");
    });

    $(".or", this.element).toggleClass("hide", list.length < 2);
  }
}